import { DataTableColumnHeader } from '@/components/dataTable/ColumnHeader';
import { getSerialNumber } from '@/components/dataTable/data-table.utils';
import { AccessLog } from '@/services/logsManagement/logsMangement.types';
import type { ColumnDef } from '@tanstack/react-table';

export function getColumns(): ColumnDef<AccessLog>[] {
  return [
    {
      accessorKey: 'sn',
      header: ({ column }) => <DataTableColumnHeader column={column} title="S.N" />,
      cell: ({ row, table }) => (
        <div className="font-medium truncate max-w-[10rem]">{getSerialNumber(table, row.index)}</div>
      ),
      enableSorting: false,
    },
    {
      accessorKey: 'pageName',
      header: ({ column }) => <DataTableColumnHeader column={column} title="Page Name" />,
      cell: ({ row }) => <div className="font-medium truncate max-w-[20rem]">{row.getValue('pageName')}</div>,
      meta: {
        label: 'Page Name',
      },
    },
    {
      accessorKey: 'userInfo',
      header: ({ column }) => <DataTableColumnHeader column={column} title="User Info" />,
      cell: ({ row }) => <div>{row.getValue('userInfo')}</div>,
      meta: {
        label: 'User Info',
      },
    },
    {
      accessorKey: 'browser',
      header: ({ column }) => <DataTableColumnHeader column={column} title="Browser" />,
      cell: ({ row }) => <div>{row.getValue('browser')}</div>,
      meta: {
        label: 'Browser',
      },
    },
    {
      accessorKey: 'statusCode',
      header: ({ column }) => <DataTableColumnHeader column={column} title="Status Code" />,
      cell: ({ row }) => <div>{row.getValue('statusCode')}</div>,
      meta: {
        label: 'Status Code',
      },
    },
    {
      accessorKey: 'ipAddress',
      header: ({ column }) => <DataTableColumnHeader column={column} title="IP Address" />,
      cell: ({ row }) => <div>{row.getValue('ipAddress')}</div>,
      meta: {
        label: 'IP Address',
      },
    },
    {
      id: 'createdDate',
      enableColumnFilter: true,
      accessorKey: 'createdDate',
      header: ({ column }) => <DataTableColumnHeader column={column} title="Date & Time" />,
      cell: ({ row }) => {
        const raw = row.getValue('createdDate');
        const formatted = new Date(raw as string).toLocaleString();

        return <div>{formatted}</div>;
      },
      meta: {
        label: 'Date & Time',
      },
    },
  ];
}
